<template>
  <el-dialog title="复制资质证明" :visible.sync="visible" width="900px" :close-on-click-modal="false" @close="handleClose">
    <div class="copy-qual-dialog">
      <el-alert title="选择需要复制的资质证明，系统将基于所选资质证明创建一份新的副本，可在新副本上修改相关信息后提交审核。" type="info" :closable="false" show-icon>
      </el-alert>

      <div class="search-bar">
        <el-input v-model="searchWord" placeholder="搜索资质包名称 / 销售 / UID" prefix-icon="el-icon-search" clearable
          @keyup.enter.native="handleSearch" @clear="handleSearch" style="width: 320px"></el-input>
        <span class="radio-label">单选</span>
      </div>

      <el-table ref="copyTable" :data="filteredList" style="width: 100%" highlight-current-row
        @current-change="handleCurrentChange" :row-class-name="tableRowClassName">
        <el-table-column width="60" label="选择">
          <template slot-scope="scope">
            <el-radio v-model="selectedPackageId" :label="scope.row.packageId"
              @change="handleRadioChange(scope.row)">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="packageName" label="名称" min-width="200">
          <template slot-scope="scope">
            <div class="text-ellipsis" :title="scope.row.packageName">
              {{ scope.row.packageName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="agentStaffName" label="渠道销售" width="90">
        </el-table-column>
        <el-table-column prop="mediaStaffName" label="渠道运营" width="90">
        </el-table-column>
        <el-table-column prop="uid" label="UID" width="120">
          <template slot-scope="scope">
            <span class="uid-link">{{ scope.row.uid }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="qualificationName" label="主体资质名称" min-width="160" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="预览" width="80" align="center">
          <template slot-scope="scope">
            <i class="el-icon-view preview-icon" @click="handlePreview(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>

      <div class="dialog-footer-info">
        <span v-if="!selectedRow">未选择任何资质证明</span>
        <span v-else>已选择：{{ selectedRow.packageName }}</span>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :disabled="!selectedRow" @click="handleConfirm">确认复制</el-button>
    </div>

    <!-- 预览弹窗 - 与 Detail.vue 结构一致 -->
    <el-dialog :title="previewData.packageName" :visible.sync="previewVisible" width="700px" append-to-body
      :close-on-click-modal="false" class="preview-dialog">
      <div class="preview-main" v-if="pageInfo.hasOwnProperty('cards')">
        <!-- 资质状态 -->
        <div class="state">
          <div class="title-l left-left">资质状态</div>
          <z-license-status :status="pageInfo.cards.base.status"></z-license-status>
          <span v-if="pageInfo.cards.base.reason"
            :style="{ color: pageInfo.cards.base.status == 3 ? '#ce3b4f' : '#A5ABC6', 'font-size': '12px' }">&nbsp;{{
              pageInfo.cards.base.reason }}</span>
          <div class="clearfix"></div>
        </div>

        <!-- 基本信息 -->
        <el-card class="padd9" v-if="pageInfo.cards.hasOwnProperty('base')">
          <div class="cont-m">
            <h2>基本信息</h2>
            <div class="clearfix"></div>
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
              <tr v-for="(data, key) in pageInfo.cards.base.data" :key="key">
                <td width="100" height="40" align="left" valign="top" class="base-td-title">
                  {{ data.label }}：
                </td>
                <td align="left" valign="top" class="base-td-value">
                  {{ data.value }}
                </td>
              </tr>
            </table>
          </div>
        </el-card>

        <!-- 我的资质信息 -->
        <div class="state inforg">
          <div class="title-l">我的资质信息</div>
        </div>
        <div class="detail-top" v-for="(item, key) in pageInfo.cards.license" :key="key">
          <z-license-detail class="padd9" v-if="pageInfo.cards.hasOwnProperty('license')"
            :license-data="item"></z-license-detail>
        </div>
      </div>
      <div class="preview-loading" v-else>
        <i class="el-icon-loading"></i> 加载中...
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="previewVisible = false">关闭</el-button>
        <el-button type="primary" @click="selectPreviewRow">选择此条复制</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getData } from "../utils/utils";
import LicenseDetail from "@/components/detail/LicenseDetail";
import LicenseStatus from "@/components/status/LicenseStatus";

export default {
  name: "CopyQualDialog",
  components: {
    "z-license-detail": LicenseDetail,
    "z-license-status": LicenseStatus
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    uid: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      searchWord: "",
      packageList: [],
      selectedPackageId: null,
      selectedRow: null,
      loading: false,
      previewVisible: false,
      previewData: {},
      pageInfo: {}
    };
  },
  computed: {
    filteredList() {
      if (!this.searchWord) {
        return this.packageList;
      }
      const keyword = this.searchWord.toLowerCase();
      return this.packageList.filter(item => {
        return (
          (item.packageName && item.packageName.toLowerCase().includes(keyword)) ||
          (item.agentStaffName && item.agentStaffName.toLowerCase().includes(keyword)) ||
          (item.uid && String(item.uid).includes(keyword))
        );
      });
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.fetchPackageList();
      } else {
        this.resetData();
      }
    }
  },
  methods: {
    fetchPackageList() {
      this.loading = true;
      const params = {};
      if (this.uid) {
        params.uid = this.uid;
      }
      if (this.$route.query["customer_id"]) {
        params["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientID"]) {
        params["clientID"] = this.$route.query["clientID"];
      }
      getData(
        "/api/package/list/copy/selected",
        params,
        (res) => {
          this.loading = false;
          if (res.code === 0) {
            this.packageList = res.data || [];
          } else {
            this.$message.warning(res.msg || "获取资质包列表失败");
          }
        },
        () => {
          this.loading = false;
        },
        false
      );
    },
    handleSearch() {
    },
    handleCurrentChange(row) {
      if (row) {
        this.selectedRow = row;
        this.selectedPackageId = row.packageId;
      }
    },
    handleRadioChange(row) {
      this.selectedRow = row;
      this.$refs.copyTable.setCurrentRow(row);
    },
    handlePreview(row) {
      this.previewData = row;
      this.pageInfo = {};
      const params = { ori_package_id: row.packageId }
      if (this.$route.query["customer_id"]) {
        params["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientID"]) {
        params["clientID"] = this.$route.query["clientID"];
      }
      getData(
        "/api/package/copy/get/preview",
        { ...params },
        (res) => {
          if (res.code === 0 && res.data) {
            this.pageInfo = res.data;
            this.previewVisible = true;
          } else {
            this.$message.warning(res.msg || "获取资质详情失败");
          }
        },
        () => {
          this.$message.error("获取资质详情失败");
        },
        true
      );
    },
    selectPreviewRow() {
      this.selectedRow = this.previewData;
      this.selectedPackageId = this.previewData.packageId;
      this.$refs.copyTable.setCurrentRow(this.previewData);
      this.previewVisible = false;
      this.$emit("confirm", this.selectedRow);
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
    handleConfirm() {
      if (!this.selectedRow) {
        this.$message.warning("请选择要复制的资质证明");
        return;
      }
      this.$emit("confirm", this.selectedRow);
    },
    resetData() {
      this.searchWord = "";
      this.selectedPackageId = null;
      this.selectedRow = null;
      this.packageList = [];
      this.pageInfo = {};
    },
    tableRowClassName({ row }) {
      if (this.selectedPackageId === row.packageId) {
        return "selected-row";
      }
      return "";
    }
  }
};
</script>

<style scoped>
.copy-qual-dialog {
  padding: 0 10px;
}

.copy-qual-dialog .el-alert {
  margin-bottom: 20px;
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
}

.copy-qual-dialog>>>.el-alert__icon {
  color: #1890ff;
}

.copy-qual-dialog>>>.el-alert__title {
  color: #1890ff;
  font-size: 14px;
}

.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.radio-label {
  margin-left: 16px;
  color: #909399;
  font-size: 14px;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.uid-link {
  color: #2a60e4;
}

.preview-icon {
  color: #2a60e4;
  cursor: pointer;
  font-size: 18px;
}

.preview-icon:hover {
  color: #1a4bc4;
}

.dialog-footer-info {
  margin-top: 16px;
  color: #909399;
  font-size: 14px;
}

.dialog-footer {
  text-align: right;
}

.copy-qual-dialog>>>.el-table .selected-row {
  background-color: #ecf5ff;
}

.copy-qual-dialog>>>.el-radio__label {
  display: none;
}

/* 预览弹窗样式 - 与 Detail.vue 一致 */
.preview-main {
  max-height: 500px;
  overflow-y: auto;
  padding: 0 10px;
}

.preview-loading {
  text-align: center;
  padding: 40px 0;
  color: #909399;
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}

.left-left {
  float: left;
}

.state .title-l {
  font-size: 18px;
  color: #2e334a;
  margin-right: 10px;
  margin-bottom: 20px;
  font-weight: bold;
}

.cont-m {
  padding: 8px 13px;
  line-height: 28px;
}

.padd9>>>h2 {
  font-size: 18px;
  color: #2e334a;
  margin-bottom: 20px;
  float: left;
  margin-right: 5px;
}

.padd9>>>table {
  font-size: 14px;
}

.padd9>>>dl {
  font-size: 14px;
}

.padd9>>>dd {
  padding-bottom: 20px;
}

.inforg {
  padding: 20px 0 0;
}

.detail-top {
  background: #fff;
  border: 1px solid #e1e6f1;
  border-radius: 4px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
  padding: 15px;
  margin-bottom: 15px;
}

.base-td-title {
  min-width: 100px;
  color: #909399;
}

.base-td-value {
  word-wrap: break-word;
  word-break: break-word;
  color: #303133;
}
</style>

<style>
.preview-dialog .el-dialog__body {
  padding: 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/CopyQualDialog.vue